<app-header></app-header>
<div class="my-account-page">
  <div class="content-banner">
    <h1>
      {{ "MY_ACCOUNT.GREETING" | translate }} {{ userInfo?.name | titlecase }}
    </h1>
  </div>
  <div class="shadow_box">
    <div class="container">
      <div class="main-account-page">
        <!-- <div class="sidebar">
          <app-sidebar></app-sidebar>
        </div> -->
        <div class="my-account-content">
          <div class="container">
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                <app-my-profile></app-my-profile>
                <div *ngIf="!socialMediaUser">
                  <app-change-password></app-change-password>
                </div>
              </div>
              <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                <app-purchase-history></app-purchase-history>
                <app-my-subscription></app-my-subscription>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
<!-- <router-outlet></router-outlet> -->
